import { useTranslation } from "next-i18next";

import { LinkButton } from "../button";

import { LinksContainer } from "./LinksContainer";

export const Links = () => {
  const { t } = useTranslation();

  return (
    <LinksContainer topLevel={true}>
      <LinksContainer>
        <LinkButton
          variant="code1"
          text={t("footer.policy")}
          url="/policy"
          target="_blank"
        />

        <LinkButton
          variant="code1"
          text="Clutch"
          url="https://clutch.co/profile/blues-brackets"
          target="_blank"
        />
      </LinksContainer>

      <LinksContainer>
        <LinkButton
          variant="code1"
          text="LinkedIn"
          url="https://www.linkedin.com/company/blues-brackets"
          target="_blank"
        />
        <LinkButton
          variant="code1"
          text="GitHub"
          url="https://github.com/Blues-Brackets"
          target="_blank"
        />

        <LinkButton
          variant="code1"
          text="Facebook"
          url="https://www.facebook.com/Blues-Brackets-101638525883176"
          target="_blank"
        />
      </LinksContainer>
    </LinksContainer>
  );
};
